import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  GeneralError1q7afgn844yvi as GeneralError,
  OperationComplete35pb9wj3i5rr0 as OperationComplete,
  ConnectionReEstablishedspo1kq7uvs59 as ConnectionReEstablished,
  NetworkErrorotwtrw4n54or as NetworkError,
  OperationError2sah6hjojh8as as OperationError,
  OperationResponseq42n5mfh87yx as OperationResponse,
  Dispose3n637sa8gbmf1 as Dispose,
  StopOperation41dlmx7s82zc as StopOperation,
  RestartConnection3ucejekzrnll6 as RestartConnection,
  StartOperation372o3p2p9vxt5 as StartOperation,
  Command2ao3eytvqoynn as Command,
  RestartConnection_instance95zpn0dkmg55 as RestartConnection_instance,
  Event2qcujbxqrid4f as Event,
  Dispose_instance3d7evwl4mdhqz as Dispose_instance,
} from './internal/WsMessage.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  SubscriptionOperationException3t8cqqpx8bt9j as SubscriptionOperationException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Key_getInstance3kkpczi3zr320 as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { jsonReader2agwreccj3lmk as jsonReader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { toApolloResponse9u5mcqg84l2p as toApolloResponse } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { CoroutineStart_UNDISPATCHED_getInstance36t7e2kqqnuqp as CoroutineStart_UNDISPATCHED_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { add2suhfggl4zvkk as add } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { IncrementalDeliveryProtocol_V0_1_getInstancefhanbu89c1sm as IncrementalDeliveryProtocol_V0_1_getInstance } from '../IncrementalDeliveryProtocol.mjs';
import { DefaultWebSocketEngine2qlkcxmcddkl7 as DefaultWebSocketEngine } from './JsWebSocketEngine.mjs';
import { Factory2jyzsj2j7cj0z as Factory } from './SubscriptionWsProtocol.mjs';
import { get_impl1focltg7f8wvg as get_impl } from '../../internal/incremental/IncrementalDeliveryProtocolImpl.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { delayp0o4nsccwai as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Channel3r72atmcithql as Channel } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { BufferOverflow_SUSPEND_getInstance1ucmryz5dsuc2 as BufferOverflow_SUSPEND_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/BufferOverflow.mjs';
import { MutableSharedFlow3g4w4npzofx4w as MutableSharedFlow } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/SharedFlow.mjs';
import {
  asSharedFlow2buz3fbrowsyg as asSharedFlow,
  onSubscription3iwvbdmbwg7iq as onSubscription,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Share.mjs';
import { Dispatchers_getInstance128lm494a5r5s as Dispatchers_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { CoroutineScopelux7s7zphw7e as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { transformWhile1eyv77fe96rjt as transformWhile } from '../../internal/flows.mjs';
import { onCompletion2zzj1m13j2omp as onCompletion } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Emitters.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function WebSocketNetworkTransport$Builder$serverUrl$slambda($serverUrl) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return $serverUrl;
  }), 0);
}
function WebSocketNetworkTransport$execute$o$collect$slambda($$this$unsafeFlow, $request) {
  return constructCallableReference((value, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $$this$unsafeFlow;
    var tmp2 = value;
    $l$block: {
      if (tmp2.j34() === $request.q43_1.toString() || tmp2.j34() == null) {
        yield* tmp0.q1e(tmp2, $completion);
        break $l$block;
      }
    }
    return Unit_instance;
  }), 1);
}
function WebSocketNetworkTransport$execute$o$collect$slambda_0($$this$unsafeFlow, $request, $incrementalResultsMerger, this$0) {
  return constructCallableReference((value, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $$this$unsafeFlow;
    var response = value;
    var tmp;
    if (response instanceof OperationResponse()) {
      var responsePayload = response.a6e_1;
      var requestCustomScalarAdapters = ensureNotNull($request.t43_1.p48(Key_getInstance()));
      var tmp_0;
      if (isDeferred(responsePayload)) {
        tmp_0 = to($incrementalResultsMerger.j68(responsePayload), $incrementalResultsMerger.f68());
      } else {
        tmp_0 = to(responsePayload, null);
      }
      var _destruct__k2r9zo = tmp_0;
      var payload = _destruct__k2r9zo.df();
      var deferredFragmentIdentifiers = _destruct__k2r9zo.ef();
      var apolloResponse = toApolloResponse(jsonReader(payload), $request.p43_1, $request.q43_1, requestCustomScalarAdapters, deferredFragmentIdentifiers);
      if (!$incrementalResultsMerger.g68()) {
        $incrementalResultsMerger.a3r();
      }
      tmp = apolloResponse;
    } else {
      if (response instanceof OperationError()) {
        tmp = errorResponse(this$0, $request, SubscriptionOperationException().n4h($request.p43_1.operationName(), response.y6d_1));
      } else {
        if (response instanceof NetworkError()) {
          tmp = errorResponse(this$0, $request, ApolloNetworkException().a4a('Network error while executing ' + $request.p43_1.operationName(), response.v6d_1));
        } else {
          var tmp_1;
          if (response instanceof ConnectionReEstablished()) {
            tmp_1 = true;
          } else {
            var tmp_2;
            if (response instanceof OperationComplete()) {
              tmp_2 = true;
            } else {
              tmp_2 = response instanceof GeneralError();
            }
            tmp_1 = tmp_2;
          }
          if (tmp_1) {
            // Inline function 'kotlin.error' call
            var message = 'Unexpected event ' + toString(response);
            throw IllegalStateException().o(toString(message));
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    var tmp$ret$1 = tmp;
    yield* tmp0.q1e(tmp$ret$1, $completion);
    return Unit_instance;
  }), 1);
}
function WebSocketNetworkTransport$execute$o$collect$slambda_1($$this$unsafeFlow, $incrementalResultsMerger) {
  return constructCallableReference((value, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $$this$unsafeFlow;
    var tmp2 = value;
    $l$block: {
      if (!$incrementalResultsMerger.h68()) {
        yield* tmp0.q1e(tmp2, $completion);
        break $l$block;
      }
    }
    return Unit_instance;
  }), 1);
}
function *supervise($this, scope, $completion) {
  var idleJob = {_v: null};
  var connectionJob = {_v: null};
  var protocol = {_v: null};
  var reopenAttemptCount = 0n;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var activeMessages = LinkedHashMap().fc();
  $l$loop_1: while (true) {
    var message = yield* $this.i6e_1.z1b($completion);
    if (isInterface(message, Event())) {
      if (message instanceof NetworkError()) {
        supervise$closeProtocol(protocol, connectionJob, idleJob);
        var tmp0_safe_receiver = $this.g6e_1;
        if ((tmp0_safe_receiver == null ? null : (yield* $(tmp0_safe_receiver(message.v6d_1, reopenAttemptCount, $completion), $completion))) === true) {
          var _unary__edvuaz = reopenAttemptCount;
          reopenAttemptCount = add(_unary__edvuaz, get_ONE());
          yield* $this.i6e_1.w1b(RestartConnection_instance, $completion);
        } else {
          reopenAttemptCount = 0n;
          $this.j6e_1.a1g(message);
        }
      } else {
        if (message instanceof ConnectionReEstablished()) {
          reopenAttemptCount = 0n;
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = activeMessages.x4().p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            $this.i6e_1.x1b(element);
          }
        } else {
          reopenAttemptCount = 0n;
          $this.j6e_1.a1g(message);
        }
      }
    } else {
      if (isInterface(message, Command())) {
        if (message instanceof Dispose()) {
          supervise$closeProtocol(protocol, connectionJob, idleJob);
          return Unit_instance;
        }
        if (protocol._v == null) {
          if (message instanceof StopOperation()) {
            activeMessages.c5(message.p6e_1.q43_1);
            continue $l$loop_1;
          }
          var tmp;
          try {
            var tmp_0 = yield* $($this.b6e_1($completion), $completion);
            var tmp_1;
            var tmp0 = $this.c6e_1;
            var tmp$ret$3;
            $l$block_0: {
              // Inline function 'kotlin.collections.any' call
              var tmp_2;
              if (isInterface(tmp0, Collection())) {
                tmp_2 = tmp0.n1();
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                tmp$ret$3 = false;
                break $l$block_0;
              }
              var _iterator__ex2g4s_0 = tmp0.p1();
              while (_iterator__ex2g4s_0.q1()) {
                var element_0 = _iterator__ex2g4s_0.r1();
                if (element_0.u4b_1 === 'Sec-WebSocket-Protocol') {
                  tmp$ret$3 = true;
                  break $l$block_0;
                }
              }
              tmp$ret$3 = false;
            }
            if (tmp$ret$3) {
              tmp_1 = $this.c6e_1;
            } else {
              tmp_1 = plus($this.c6e_1, new (HttpHeader())('Sec-WebSocket-Protocol', $this.f6e_1.h1()));
            }
            tmp = yield* $this.d6e_1.q6e(tmp_0, tmp_1, $completion);
          } catch ($p) {
            var tmp_3;
            if ($p instanceof Exception()) {
              var e = $p;
              yield* $this.i6e_1.w1b(new (NetworkError())(e), $completion);
              continue $l$loop_1;
            } else {
              throw $p;
            }
          }
          var webSocketConnection = tmp;
          protocol._v = $this.f6e_1.y6c(webSocketConnection, $this.o6e_1, scope);
          try {
            yield* ensureNotNull(protocol._v).h6d($completion);
          } catch ($p_0) {
            if ($p_0 instanceof Exception()) {
              var e_0 = $p_0;
              protocol._v = null;
              yield* $this.i6e_1.w1b(new (NetworkError())(e_0), $completion);
              continue $l$loop_1;
            } else {
              throw $p_0;
            }
          }
          var tmp_4 = CoroutineStart_UNDISPATCHED_getInstance();
          connectionJob._v = launch(scope, VOID, tmp_4, WebSocketNetworkTransport$supervise$slambda(protocol));
        }
        if (message instanceof StartOperation()) {
          // Inline function 'kotlin.collections.set' call
          var key = message.r6e_1.q43_1;
          activeMessages.b5(key, message);
          ensureNotNull(protocol._v).o6d(message.r6e_1);
        } else {
          if (message instanceof StopOperation()) {
            activeMessages.c5(message.p6e_1.q43_1);
            ensureNotNull(protocol._v).r6b(message.p6e_1);
          } else {
            if (message instanceof RestartConnection()) {
              yield* $this.i6e_1.w1b(new (ConnectionReEstablished())(), $completion);
            }
          }
        }
        if (activeMessages.n1()) {
          idleJob._v = launch(scope, VOID, VOID, WebSocketNetworkTransport$supervise$slambda_0($this, protocol, connectionJob, idleJob));
        } else {
          var tmp2_safe_receiver = idleJob._v;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.hy();
          }
          idleJob._v = null;
        }
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  return Unit_instance;
}
function errorResponse($this, request, apolloException) {
  var tmp0_requestUuid = request.q43_1;
  var tmp1_operation = request.p43_1;
  return Builder().r44(tmp1_operation, tmp0_requestUuid).w44(apolloException).x44(true).e3a();
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.n65_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.o65_1 = ArrayList().p2();
        this.p65_1 = null;
        this.q65_1 = null;
        this.r65_1 = null;
        this.s65_1 = null;
        this.t65_1 = IncrementalDeliveryProtocol_V0_1_getInstance();
      }
      a64(serverUrl) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        tmp.n65_1 = WebSocketNetworkTransport$Builder$serverUrl$slambda(serverUrl);
        return this;
      }
      y65(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.n65_1 = serverUrl;
        return this;
      }
      u65(webSocketEngine) {
        // Inline function 'kotlin.apply' call
        this.p65_1 = webSocketEngine;
        return this;
      }
      v65(idleTimeoutMillis) {
        // Inline function 'kotlin.apply' call
        this.q65_1 = idleTimeoutMillis;
        return this;
      }
      w65(protocolFactory) {
        // Inline function 'kotlin.apply' call
        this.r65_1 = protocolFactory;
        return this;
      }
      x65(reopenWhen) {
        // Inline function 'kotlin.apply' call
        this.s65_1 = reopenWhen;
        return this;
      }
      e3a() {
        var tmp0_elvis_lhs = this.n65_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No serverUrl specified';
          throw IllegalStateException().o(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp_0 = tmp;
        var tmp_1 = this.o65_1;
        var tmp1_elvis_lhs = this.p65_1;
        var tmp_2 = tmp1_elvis_lhs == null ? new (DefaultWebSocketEngine())() : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = this.q65_1;
        var tmp_3 = tmp2_elvis_lhs == null ? 60000n : tmp2_elvis_lhs;
        var tmp3_elvis_lhs = this.r65_1;
        return new (WebSocketNetworkTransport())(tmp_0, tmp_1, tmp_2, tmp_3, tmp3_elvis_lhs == null ? new (Factory())() : tmp3_elvis_lhs, this.s65_1, get_impl(this.t65_1));
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $_0 {
      constructor(function_0) {
        this.s6e_1 = function_0;
      }
      *q1e(value, $completion) {
        return yield* $(this.s6e_1(value, $completion), $completion);
      }
      j5() {
        return this.s6e_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.j5(), other.j5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.j5());
      }
    }
    initMetadataForClass($_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $_0;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
function WebSocketNetworkTransport$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* /*#__NOINLINE__*/supervise(this$0, $this$launch, $completion);
    return Unit_instance;
  }), 1);
}
var WebSocketNetworkTransport$listener$1Class;
function WebSocketNetworkTransport$listener$1() {
  if (WebSocketNetworkTransport$listener$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.t6e_1 = this$0;
      }
      n6d(id, payload) {
        this.t6e_1.i6e_1.x1b(new (OperationResponse())(id, payload));
      }
      m6d(id, payload) {
        this.t6e_1.i6e_1.x1b(new (OperationError())(id, payload));
      }
      k6d(id) {
        this.t6e_1.i6e_1.x1b(new (OperationComplete())(id));
      }
      l6d(payload) {
        this.t6e_1.i6e_1.x1b(new (GeneralError())(payload));
      }
      u6e(cause) {
        this.t6e_1.i6e_1.x1b(new (NetworkError())(cause));
      }
    }
    initMetadataForClass($);
    WebSocketNetworkTransport$listener$1Class = $;
  }
  return WebSocketNetworkTransport$listener$1Class;
}
function supervise$closeProtocol(protocol, connectionJob, idleJob) {
  var tmp0_safe_receiver = protocol._v;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.m6();
  }
  protocol._v = null;
  var tmp1_safe_receiver = connectionJob._v;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.hy();
  }
  connectionJob._v = null;
  var tmp2_safe_receiver = idleJob._v;
  if (tmp2_safe_receiver == null)
    null;
  else {
    tmp2_safe_receiver.hy();
  }
  idleJob._v = null;
}
function WebSocketNetworkTransport$supervise$slambda($protocol) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* ensureNotNull($protocol._v).u6d($completion);
    return Unit_instance;
  }), 1);
}
function WebSocketNetworkTransport$supervise$slambda_0(this$0, $protocol, $connectionJob, $idleJob) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay(this$0.e6e_1, $completion);
    supervise$closeProtocol($protocol, $connectionJob, $idleJob);
    return Unit_instance;
  }), 1);
}
function WebSocketNetworkTransport$execute$slambda(this$0, $request) {
  return constructCallableReference(($this$onSubscription, $completion) => orPromise($completion, function *($completion) {
    yield* this$0.i6e_1.w1b(new (StartOperation())($request), $completion);
    return Unit_instance;
  }), 1);
}
var WebSocketNetworkTransport$execute$$inlined$filter$1Class;
function WebSocketNetworkTransport$execute$$inlined$filter$1() {
  if (WebSocketNetworkTransport$execute$$inlined$filter$1Class === VOID) {
    class $ {
      constructor($this, $request) {
        this.v6e_1 = $this;
        this.w6e_1 = $request;
      }
      *p1e(collector, $completion) {
        var tmp = WebSocketNetworkTransport$execute$o$collect$slambda(collector, this.w6e_1);
        yield* this.v6e_1.t1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      t1d(collector, $completion) {
        return this.p1e(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$$inlined$filter$1Class = $;
  }
  return WebSocketNetworkTransport$execute$$inlined$filter$1Class;
}
function WebSocketNetworkTransport$execute$slambda_0($request) {
  return constructCallableReference(($this$transformWhile, it, $completion) => orPromise($completion, function *($completion) {
    var tmp0_subject = it;
    var tmp;
    if (tmp0_subject instanceof OperationComplete()) {
      tmp = false;
    } else {
      if (tmp0_subject instanceof ConnectionReEstablished()) {
        tmp = false;
      } else {
        if (tmp0_subject instanceof NetworkError()) {
          yield* $this$transformWhile.q1e(it, $completion);
          tmp = false;
        } else {
          if (tmp0_subject instanceof GeneralError()) {
            println('Received general error while executing operation ' + $request.p43_1.operationName() + ': ' + toString_0(it.x6e_1));
            tmp = true;
          } else {
            yield* $this$transformWhile.q1e(it, $completion);
            tmp = true;
          }
        }
      }
    }
    return tmp;
  }), 2);
}
var WebSocketNetworkTransport$execute$$inlined$map$1Class;
function WebSocketNetworkTransport$execute$$inlined$map$1() {
  if (WebSocketNetworkTransport$execute$$inlined$map$1Class === VOID) {
    class $ {
      constructor($this, $request, $incrementalResultsMerger, this$0) {
        this.z6e_1 = $this;
        this.a6f_1 = $request;
        this.b6f_1 = $incrementalResultsMerger;
        this.c6f_1 = this$0;
      }
      *p1e(collector, $completion) {
        var tmp = WebSocketNetworkTransport$execute$o$collect$slambda_0(collector, this.a6f_1, this.b6f_1, this.c6f_1);
        yield* this.z6e_1.t1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      t1d(collector, $completion) {
        return this.p1e(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$$inlined$map$1Class = $;
  }
  return WebSocketNetworkTransport$execute$$inlined$map$1Class;
}
var WebSocketNetworkTransport$execute$$inlined$filterNot$1Class;
function WebSocketNetworkTransport$execute$$inlined$filterNot$1() {
  if (WebSocketNetworkTransport$execute$$inlined$filterNot$1Class === VOID) {
    class $ {
      constructor($this, $incrementalResultsMerger) {
        this.d6f_1 = $this;
        this.e6f_1 = $incrementalResultsMerger;
      }
      *p1e(collector, $completion) {
        var tmp = WebSocketNetworkTransport$execute$o$collect$slambda_1(collector, this.e6f_1);
        yield* this.d6f_1.t1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      t1d(collector, $completion) {
        return this.p1e(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$$inlined$filterNot$1Class = $;
  }
  return WebSocketNetworkTransport$execute$$inlined$filterNot$1Class;
}
function WebSocketNetworkTransport$execute$slambda_1(this$0, $request) {
  return constructCallableReference(($this$onCompletion, it, $completion) => orPromise($completion, function *($completion) {
    yield* this$0.i6e_1.w1b(new (StopOperation())($request), $completion);
    return Unit_instance;
  }), 2);
}
var WebSocketNetworkTransportClass;
function WebSocketNetworkTransport() {
  if (WebSocketNetworkTransportClass === VOID) {
    class $ {
      constructor(serverUrl, headers, webSocketEngine, idleTimeoutMillis, protocolFactory, reopenWhen, incrementalDeliveryProtocolImpl) {
        webSocketEngine = webSocketEngine === VOID ? new (DefaultWebSocketEngine())() : webSocketEngine;
        idleTimeoutMillis = idleTimeoutMillis === VOID ? 60000n : idleTimeoutMillis;
        protocolFactory = protocolFactory === VOID ? new (Factory())() : protocolFactory;
        this.b6e_1 = serverUrl;
        this.c6e_1 = headers;
        this.d6e_1 = webSocketEngine;
        this.e6e_1 = idleTimeoutMillis;
        this.f6e_1 = protocolFactory;
        this.g6e_1 = reopenWhen;
        this.h6e_1 = incrementalDeliveryProtocolImpl;
        this.i6e_1 = Channel(2147483647);
        this.j6e_1 = MutableSharedFlow(0, 2147483647, BufferOverflow_SUSPEND_getInstance());
        this.k6e_1 = asSharedFlow(this.j6e_1);
        this.l6e_1 = this.j6e_1.e1g();
        this.m6e_1 = Dispatchers_getInstance().b14_1.s13(1);
        this.n6e_1 = CoroutineScope(this.m6e_1);
        launch(this.n6e_1, VOID, VOID, WebSocketNetworkTransport$slambda(this));
        var tmp = this;
        tmp.o6e_1 = new (WebSocketNetworkTransport$listener$1())(this);
      }
      h66(request) {
        var incrementalResultsMerger = this.h6e_1.x67();
        // Inline function 'kotlinx.coroutines.flow.filter' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        var this_0 = onSubscription(this.k6e_1, WebSocketNetworkTransport$execute$slambda(this, request));
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        var tmp = new (WebSocketNetworkTransport$execute$$inlined$filter$1())(this_0, request);
        // Inline function 'kotlinx.coroutines.flow.map' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        var this_1 = transformWhile(tmp, WebSocketNetworkTransport$execute$slambda_0(request));
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        // Inline function 'kotlinx.coroutines.flow.filterNot' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        var this_2 = new (WebSocketNetworkTransport$execute$$inlined$map$1())(this_1, request, incrementalResultsMerger, this);
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        var tmp_0 = new (WebSocketNetworkTransport$execute$$inlined$filterNot$1())(this_2, incrementalResultsMerger);
        return onCompletion(tmp_0, WebSocketNetworkTransport$execute$slambda_1(this, request));
      }
      n10() {
        this.i6e_1.x1b(Dispose_instance);
      }
    }
    initMetadataForClass($, 'WebSocketNetworkTransport', VOID, VOID, VOID, [1]);
    WebSocketNetworkTransportClass = $;
  }
  return WebSocketNetworkTransportClass;
}
function isDeferred(_this__u8e3s4) {
  return _this__u8e3s4.w4().t2('hasNext');
}
//region block: exports
export {
  Builder_0 as Builder3moivcm5iuump,
};
//endregion

//# sourceMappingURL=WebSocketNetworkTransport.mjs.map
